import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import EcosystemSection from "@/components/EcosystemSection";
import ServicesSection from "@/components/ServicesSection";
import IndustrySection from "@/components/IndustrySection";
import ProcessSection from "@/components/ProcessSection";
import PortfolioSection from "@/components/PortfolioSection";
import TestimonialSection from "@/components/TestimonialSection";
import TestimonialStructuredData from "@/components/TestimonialStructuredData";
import FAQSection from "@/components/FAQSection";
import PageSpecificFAQStructuredData from "@/components/PageSpecificFAQStructuredData";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead page="home" />
      <Header />
      <HeroSection />
      <AboutSection />
      <EcosystemSection />
      <ServicesSection />
      <IndustrySection />
      <ProcessSection />
      <PortfolioSection />
      <TestimonialSection />
      <TestimonialStructuredData />
      <FAQSection />
      <PageSpecificFAQStructuredData namespace="faq" faqKey="faqs" />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
